var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowCircleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.68,
    height: 24.68,
    viewBox: "0 0 24.68 24.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_arrow-circle-down",
    "data-name": "vuesax/bulk/arrow-circle-down",
    transform: "translate(-556 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-circle-down",
    transform: "translate(556 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.567,10.283A10.283,10.283,0,1,1,10.283,0,10.283,10.283,0,0,1,20.567,10.283Z",
    transform: "translate(2.057 2.057)",
    fill: "#f5f7f8",
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.4,5.17a.763.763,0,0,1-.545-.226L.224,1.314A.771.771,0,0,1,1.314.224L4.4,3.309,7.484.224a.771.771,0,1,1,1.09,1.09l-3.63,3.63A.763.763,0,0,1,4.4,5.17Z",
    transform: "translate(7.941 10.265)",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H24.68V24.68H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleDown);
export default __webpack_public_path__ + "static/media/arrow-circle-down.c1608f84af29f149ec4110ecb32bdad4.svg";
export { ForwardRef as ReactComponent };